const initialState = {
    orderBy: { value: 'price', label: 'Price' },
    orderAsc: true
};

let sortReducer = function(data = initialState, action) {
    switch (action.type) {
        case 'APPLY_SORTING':
            return action.data;
        default:
            return data;
    }
};

export default sortReducer;
